import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { ColorUtil } from '../../../utils/color-util';

export type WellProps = {
  /**
   * The fill, and with it which kind of thing is wearing the well - each carries its own edge and
   * corner, because a chip in a list of them and a bubble holding a message are not asking for the
   * same box.
   */
  background?:
    'light' | 'gray' | 'sky blue' | 'light blue' | 'blue' | 'high attention';
  /**
   * An edge around the fill, for a well that has to read as its own object among others. Off by
   * default: a fill against a page already says where it stops.
   */
  border?: boolean;
  children: React.ReactNode;
  className?: string;
  /** Reads as set aside rather than gone: the well is still there, holding back. */
  dimmed?: boolean;
  name?: string;
  /** The browser's own tooltip, for a well whose fill is saying something the words do not. */
  title?: string;
};

export const Well = ({
  background = 'gray',
  border,
  className,
  children,
  dimmed,
  name,
  title,
}: WellProps) => (
  <div
    className={AttrsHelper.formatClassname(
      'well',
      ColorUtil.nameClass({ color: background, prefix: 'background' }),
      border && 'well-border',
      dimmed && 'well-dimmed',
      className
    )}
    data-test={name}
    title={title}
  >
    {children}
  </div>
);
